import React from "react";
import './Card.css'

function Card({children, margined}) {
    return (
        <div className={'card' + (margined ? ' margined' : '')}>
            {children}
        </div>
    )   
}

export default React.memo(Card);